<!-- /* * Confidential and Proprietary. * Do not distribute without 1-800-Flowers.com, Inc. consent. *
Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved. */ -->

{#if idx === $chatSession.messages.length - 1 && message.sender === 'bot' && showFeedbackButtons}
	<div class="reaction-container">
		<button
			class="reaction {$messageReaction === 1 ? 'selected' : ''}"
			on:mouseover={() => {
				const tooltip = document.querySelector('.tooltip-good');
				if (tooltip instanceof HTMLSpanElement && tooltip?.style) {
					tooltip.style.visibility = 'visible';
					tooltip.style.opacity = '1';
				}
			}}
			on:mouseout={() => {
				const tooltip = document.querySelector('.tooltip-good');
				if (tooltip instanceof HTMLSpanElement && tooltip?.style) {
					tooltip.style.visibility = 'hidden';
					tooltip.style.opacity = '0';
				}
			}}
			on:click={() => $messageReaction !== 1 && reaction(1, message?.params?.run_id)}
			aria-label="Good response"
		>
			<svg
				xmlns="http://www.w3.org/2000/svg"
				viewBox="0 0 32 32"
				width="16"
				height="16"
				fill="grey"
			>
				<path
					d="M27 11h-8.52L19 9.8A6.42 6.42 0 0 0 13 1a1 1 0 0 0-.93.63L8.32 11H5a3 3 0 0 0-3 3v14a3 3 0 0 0 3 3h18.17a3 3 0 0 0 2.12-.88l3.83-3.83a3 3 0 0 0 .88-2.12V14a3 3 0 0 0-3-3zM4 28V14a1 1 0 0 1 1-1h3v16H5a1 1 0 0 1-1-1zm24-3.83a1 1 0 0 1-.29.71l-3.83 3.83a1.05 1.05 0 0 1-.71.29H10V12.19l3.66-9.14a4.31 4.31 0 0 1 3 1.89 4.38 4.38 0 0 1 .44 4.12l-1 2.57A1 1 0 0 0 17 13h10a1 1 0 0 1 1 1z"
					data-name="thumbs up"
				/>
			</svg>
			<span class="tooltip">Helpful Response</span>
		</button>

		<button
			class="reaction {$messageReaction === 0 ? 'selected' : ''}"
			on:mouseover={() => {
				const tooltip = document.querySelector('.tooltip-bad');
				if (tooltip instanceof HTMLSpanElement && tooltip?.style) {
					tooltip.style.visibility = 'visible';
					tooltip.style.opacity = '1';
				}
			}}
			on:mouseout={() => {
				const tooltip = document.querySelector('.tooltip-bad');
				if (tooltip instanceof HTMLSpanElement && tooltip?.style) {
					tooltip.style.visibility = 'hidden';
					tooltip.style.opacity = '0';
				}
			}}
			on:click={() => $messageReaction !== 0 && reaction(0, message?.params?.run_id)}
			aria-label="Bad response"
		>
			<svg
				xmlns="http://www.w3.org/2000/svg"
				viewBox="0 0 32 32"
				width="16"
				height="16"
				fill="grey"
			>
				<path
					d="m29.12 5.71-3.83-3.83A3 3 0 0 0 23.17 1H5a3 3 0 0 0-3 3v14a3 3 0 0 0 3 3h3.32l3.75 9.37A1 1 0 0 0 13 31a6.42 6.42 0 0 0 6-8.8l-.52-1.2H27a3 3 0 0 0 3-3V7.83a3 3 0 0 0-.88-2.12zM4 18V4a1 1 0 0 1 1-1h3v16H5a1 1 0 0 1-1-1zm24 0a1 1 0 0 1-1 1H17a1 1 0 0 0-.93 1.37l1 2.57a4.38 4.38 0 0 1-.44 4.12 4.31 4.31 0 0 1-3 1.89L10 19.81V3h13.17a1 1 0 0 1 .71.29l3.83 3.83a1 1 0 0 1 .29.71z"
					data-name="thumb down"
				/>
			</svg>
			<span class="tooltip">Unhelpful Response</span>
		</button>
	</div>
{/if}

<script lang="ts">
	import { sendSignal } from '$lib/apis/webchat/sendSignal';
	import { chatSession } from '$lib/stores/chatSessionStore';
	import { datadogLogs } from '@datadog/browser-logs';
	import { type Writable } from 'svelte/store';

	export let messageReaction: Writable<number>;
	export let idx: number;
	export let message: {
		sender: string;
		message: string;
		type?: string;
		params?: Record<string, any>;
	};
	const showFeedbackButtons = $chatSession.flags?.['flora-feedback-enabled'];
	messageReaction.update(() => -1);

	const reaction = async (reaction: number, run_id: string) => {
		messageReaction.update(() => reaction);
		datadogLogs.logger.info(
			`[Conv-ui] Reaction Pressed - brand: ${$chatSession.brand} channel: ${$chatSession.channel} browser_uuid: ${$chatSession.browseruuid} conversation_id: ${$chatSession?.conversation_id} reaction_value: ${reaction === 1 ? 'Good Response' : 'Bad Response'}`
		);
		await sendSignal(
			{
				conversation_id: $chatSession.conversation_id,
				brand_code: $chatSession.brand,
				channel: $chatSession.channel,
				type: 'reaction',
				params: {
					agent: $chatSession.agent,
					run_id,
					reaction_value: reaction,
					customer: {
						email: $chatSession.email,
						contact_id: $chatSession.contactId,
						browser_uuid: $chatSession.browseruuid,
						first: $chatSession.firstName,
						last: $chatSession.lastName
					}
				}
			},
			$chatSession.token
		);
	};
</script>

<style>
	.reaction-container {
		display: flex;
		align-items: center;
		margin-left: 2rem;
		margin-top: -16px;
		margin-bottom: 10px;
	}

	.reaction {
		cursor: pointer;
		border: none;
		background-color: transparent;
		margin-left: 10px;
		padding: 5px;
		border-radius: 25%;
		opacity: 0.6;
		transition:
			opacity 0.5s ease,
			background-color 0.2s ease;
		position: relative;
	}

	.reaction:hover {
		fill: #000000;
		opacity: 1;
		stroke: #000000;
		stroke-width: 1;
	}

	.reaction.selected {
		fill: #000000;
		opacity: 1;
		stroke: #000000;
		stroke-width: 1;
	}

	.reaction.selected:hover .tooltip {
		visibility: visible;
		opacity: 1;
	}

	.tooltip {
		position: absolute;
		top: -150%;
		left: 50%;
		transform: translateX(-50%);
		background-color: #333;
		color: #fff;
		padding: 5px 10px;
		border-radius: 3px;
		visibility: hidden;
		opacity: 0;
		transition: opacity 0.2s ease-in-out;
		pointer-events: none;
	}

	.reaction:hover .tooltip {
		visibility: visible;
		opacity: 1;
	}
</style>
